// Note: do not remove trailing slash. It is expected for page to preserve query params after redirection.
// Removing trailing slach will break the redirection
export const IRCTC_STATION_CHANGE_URL = "https://webviews.swiggy.com/portal-static-page/station_select/";
export const IRCTC_START_DATE_FORMAT = "yyyy-MM-dd";

export const IRCTC_SLA_PREFIX_ORIGINAL = "Delivery at";
export const IRCTC_SLA_PREFIX_REPLACEMENT = "Meal delivery on";
export const IRCTC_DELIVERY_AT_STATION_TEXT = "at {0}";
export const IRCTC_SEAT_LABEL = "Seat: {0}/{1}";
export const IRCTC_SEAT_LABEL_FALLBACK = "Seat: --";
export const IRCTC_TRAIN_NUMBER_SUFFIX = ", {0}";
export const IRCTC_TRAIN_NAME_SUFFIX = " - {0}";
export const IRCTC_ORDER_TYPE_SUBTITLE = "{0}{1}{2}";

export const IRCTC_STATION_CHANGE_DEEPLINK = "swiggy://webviewV2?webview_url={0}";

export const IRCTC_TEST_IDS = {
    DELIVERY_DETAILS_CTA: "irctc-delivery-details-cta",
    DELIVERY_CONTACT_CTA: "irctc-delivery-contact-cta",
};
